module.exports = __webpack_public_path__ + "static/media/erik-lucatero-2.858fe653.jpg";